import { useEffect, useReducer } from 'react';
import { FEATURE_FLAGS, usePartnerFeatureFlag } from 'support/helpers/featureFlags/featureFlags';
import { DocumentType } from 'support/types';

export enum CreateDocumentSteps {
  PRICAT_UPLOAD = 'PRICAT_UPLOAD',
  DOCUMENT_CREATION = 'DOCUMENT_CREATION',
}

type Action = { type: 'GOTO_PRICAT_UPLOAD' } | { type: 'GOTO_DOCUMENT_CREATION' };

const reducer = (state: CreateDocumentSteps, action: Action): CreateDocumentSteps => {
  switch (action.type) {
    case 'GOTO_PRICAT_UPLOAD':
      return CreateDocumentSteps.PRICAT_UPLOAD;
    case 'GOTO_DOCUMENT_CREATION':
      return CreateDocumentSteps.DOCUMENT_CREATION;
    default:
      return state;
  }
};

export const useCreateDocumentSteps = ({ documentType }: { documentType: DocumentType | undefined }) => {
  const { enabled: priceCatalogsEnabled, isLoading: isLoadingPricatCatalogFeatureFlag } = usePartnerFeatureFlag(
    FEATURE_FLAGS.TEMPORARY_PRICE_CATALOGS,
  );
  const isCreatingPricat = documentType === DocumentType.productCatalog;
  const [state, dispatch] = useReducer(reducer, CreateDocumentSteps.DOCUMENT_CREATION);
  const isLoading = isLoadingPricatCatalogFeatureFlag;

  useEffect(() => {
    if (!isLoadingPricatCatalogFeatureFlag) {
      dispatch({
        type: priceCatalogsEnabled && isCreatingPricat ? 'GOTO_PRICAT_UPLOAD' : 'GOTO_DOCUMENT_CREATION',
      });
    }
  }, [isCreatingPricat, isLoadingPricatCatalogFeatureFlag, priceCatalogsEnabled]);

  return { state, dispatch, isLoading };
};
